import {
    apiRequest,
    cpnsUploadSK,
    cpnsDetail,
} from "../../../../../services/adapters/kepegawaian/cpnsService"

class UploadSKRepository {

    fetchUploadSk = async (query) => {
        return await apiRequest("post", cpnsUploadSK, {
            body: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", cpnsDetail, {
            params: query
        }, true)
    }
}

export default UploadSKRepository